/*
 * Muñequita Vintage — subtle parallax drift on hero-style imagery.
 *
 * Applies a small, clamped translateY (plus a slight scale so the
 * translated image never reveals empty edges inside its cropped
 * container) to the site's big editorial images as the page scrolls:
 * the "Shop by world" tiles, the Brand story image, and a collection
 * page's banner image, if one is set. Product-grid thumbnails are
 * deliberately left alone — parallax on small repeated cards reads as
 * noisy rather than premium.
 *
 * Only runs on non-touch pointers, and respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;

  var SELECTOR = [
    '[class*="sbw-tile-"] img',
    '[class*="bs-media-"] img',
    '.collection-hero__image-container img',
  ].join(',');

  var MAX_OFFSET_PX = 40;
  var STRENGTH = 0.08;

  function init() {
    var images = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!images.length) return;

    images.forEach(function (img) {
      img.classList.add('js-parallax-image');
    });

    var active = new Set();

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            active.add(entry.target);
          } else {
            active.delete(entry.target);
            entry.target.style.transform = '';
          }
        });
      },
      { rootMargin: '20% 0px 20% 0px' }
    );

    images.forEach(function (img) {
      observer.observe(img);
    });

    var ticking = false;

    function update() {
      ticking = false;
      active.forEach(function (img) {
        var container = img.parentElement;
        if (!container) return;
        var rect = container.getBoundingClientRect();
        var viewportCenter = window.innerHeight / 2;
        var elementCenter = rect.top + rect.height / 2;
        var distance = elementCenter - viewportCenter;
        var offset = Math.max(-MAX_OFFSET_PX, Math.min(MAX_OFFSET_PX, distance * STRENGTH));
        img.style.transform = 'translateY(' + offset.toFixed(1) + 'px) scale(1.15)';
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', update);

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
